import {
    CLEAR_PENDING_REGISTRATION,
    CREATE_PENDING_REGISTRATION,
    LOGOUT,
    SET_LANGUAGE,
    SET_TOKEN,
    SET_USER_DETAILS_LOADED,
    UPDATE_USER_DETAILS
} from "../action/userActions"
import jwt_decode from "jwt-decode";

const initialState = {
    isLoggedIn: false,
    detailsLoaded: false,
    servicePointsLoaded: false,
    pendingRegistration: {}
}

export const userReducer = function (state = initialState, action) {
    switch (action.type) {
        case SET_LANGUAGE: {
            return {
                ...state,
                languageCode: action.languageCode
            }
        }

        case SET_TOKEN: {
            const newToken = action.token

            if (!!newToken) {
                const jwt = jwt_decode(newToken)

                return {
                    ...state,
                    token: newToken,
                    isLoggedIn: true,
                    validUntil: jwt.exp,
                    details: {
                        ...state.details,
                        login: jwt.sub
                    }
                }
            }

            return {
                ...initialState,
                languageCode: state.languageCode
            }
        }

        case LOGOUT: {
            return {
                ...initialState,
                languageCode: state.languageCode
            }
        }

        case CREATE_PENDING_REGISTRATION: {
            return {
                ...state,
                pendingRegistration: {
                    email: action.email,
                    customerType: action.customerType
                }
            }
        }

        case CLEAR_PENDING_REGISTRATION: {
            return {
                ...state,
                pendingRegistration: {}
            }
        }

        case UPDATE_USER_DETAILS: {
            return {
                ...state,
                details: {
                    ...state.details,
                    ...action.details
                }
            }
        }

        case SET_USER_DETAILS_LOADED: {
            return {
                ...state,
                detailsLoaded: true
            }
        }

        default:
            return state
    }
}